import React, {Component} from "react";
import {Redirect} from "react-router-dom";
import {LayoutSplashScreen} from "../../../../core/layout";

class Logout extends Component {
  // componentDidMount() {
  //   this.props.logout();
  // }

  render() {
    const { hasAuthToken } = this.props;
    return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth/login" />;
  }
}

export default Logout;
